import React, { memo } from 'react';
import { Image } from '@yme/atoms/image';
import { ButtonLinkWrapper } from '@yme/molecules/buttons';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { AspectRatio } from '@yme/utils/constants';
import { FlexWrapperStyled, SegmentPreviewCardTextStyled } from './styled';
function SegmentPreviewCardComponent(props) {
    const { title, link, imageObj, isRightToLeft = false, bottomIndent, topIndent, onClick, indentBetweenElement = '0px', } = props;
    return (React.createElement(FlexWrapperStyled, { alignItems: "center", flexDirection: "column", mb: bottomIndent, mt: topIndent, isRightToLeft: isRightToLeft, gap: indentBetweenElement },
        React.createElement(ButtonLinkWrapper, { buttonLink: link, onClick: onClick },
            React.createElement(FlexWrapper, { flexDirection: "column" },
                React.createElement(Image, { ...imageObj, aspectRatio: AspectRatio.RectangleLevel3, objectFit: "contain", alt: title }),
                React.createElement(RegularTextLevel3, { textAlign: "center" },
                    React.createElement(SegmentPreviewCardTextStyled, null, title))))));
}
export const SegmentPreviewCard = memo(SegmentPreviewCardComponent);
SegmentPreviewCard.displayName = 'SegmentPreviewCard_Molecule';
